<template>
  <div
    class="upcoming-events"
    :class="{
      'container': !carousel
    }"
  >
    <div class="upcoming-events-wrapper">
      <template v-if="carousel">
        <upcoming-events-carousel />
      </template>
      <template v-else>
        <upcoming-events-list />
      </template>
    </div>
  </div>
</template>

<script>
  import UpcomingEventsList from './variants/list/upcoming-events-list.vue'
  import UpcomingEventsCarousel from './variants/carousel/upcoming-events-carousel.vue'

  export default {
    name: 'UpcomingEvents',
    components: {
      UpcomingEventsList,
      UpcomingEventsCarousel
    },
    provide() {
      return {
        events: this.events,
        dictionary: this.dictionary,
        settings: this.settings,
        calendarLang: this.calendarLang,
        carousel: this.carousel
      }
    },
    props: {
      events: {
        type: Array,
        required: true,
        default: () => ([])
      },
      dictionary: {
        type: Object,
        required: true,
        default: () => ({})
      },
      settings: {
        type: Object,
        default: () => ({})
      },
      calendarLang: {
        type: Object,
        default: () => ({})
      },
      carousel: {
        type: Boolean,
        default: false
      }
    },
  }
</script>
